import React from "react";
import BondPlayInfoModal from "./BondPlayInfoModal";
import { formatBondDiceCoin, formatOddsMultiplier } from "../../utils/bondDiceHelpers";

const DEFAULT_CONSTANTS = {
  minStake: 100,
  maxStake: 500_000,
  faceOdds: 6,
  groupOdds: 2,
  platformFeeRate: 0.05,
  pendingPlayTtlMs: 60_000,
};

const BondDiceInfoModal = ({ open = false, onClose, constants = DEFAULT_CONSTANTS }) => {
  const minStake = constants?.minStake || DEFAULT_CONSTANTS.minStake;
  const maxStake = constants?.maxStake || DEFAULT_CONSTANTS.maxStake;
  const faceOdds = constants?.faceOdds || DEFAULT_CONSTANTS.faceOdds;
  const groupOdds = constants?.groupOdds || constants?.odds || DEFAULT_CONSTANTS.groupOdds;
  const platformFee = Math.round((constants?.platformFeeRate || 0.05) * 100);
  const playSeconds = Math.round(
    (constants?.pendingPlayTtlMs || DEFAULT_CONSTANTS.pendingPlayTtlMs) / 1000
  );

  return (
    <BondPlayInfoModal
      open={open}
      onClose={onClose}
      titleId="bplay-dice-info-title"
      title="Bond Dice"
      subtitle="Pick a face or group, reserve a roll, then play before the timer runs out."
      sections={[
        {
          title: "Reserve a roll",
          items: [
            <>
              Pick an exact face (1–6), <strong>Even/Odd</strong>, or an interval (<strong>1–3</strong> / <strong>4–6</strong>).
            </>,
            <>
              Stake {formatBondDiceCoin(minStake)}–{formatBondDiceCoin(maxStake)} COIN. The investor pool covers your max win.
            </>,
          ],
        },
        {
          title: "Odds",
          items: [
            <>Exact face pays {formatOddsMultiplier(faceOdds)} gross. Even, odd, and interval picks pay {formatOddsMultiplier(groupOdds)} gross.</>,
            <>Max win is shown before you reserve — it includes your stake back on a win.</>,
          ],
        },
        {
          title: "Roll & payout",
          items: [
            <>After reserving, tap <strong>Roll</strong> within {playSeconds} seconds or your stake is refunded.</>,
            <>Cancel anytime before rolling for a full refund.</>,
            <>Platform fee ({platformFee}%) applies to player profit on wins.</>,
          ],
        },
      ]}
    />
  );
};

export default BondDiceInfoModal;
